import React from 'react';
import { Modal as BSModal, Glyphicon } from 'react-bootstrap';
import { getElementStyles } from '../../graph/elements/elementStyles';
import '../../../../css/graph/config-modal.less';

const ConfigModalHeader = ({ title, elementType }) => {

    const element = getElementStyles(elementType);
    const backgroundFill = { background: element.border.fill };

    return (
        <>
            <span className="modal-element-header">
                <span className="modal-element-top-bar" style={backgroundFill} />
                <span className="modal-element-icon-background" style={backgroundFill}>
                    <Glyphicon
                        className="modal-element-icon"
                        glyph={element.icon}
                    />
                </span>
                <BSModal.Title className="modal-element-title">
                    {title}
                </BSModal.Title>
            </span>
        </>
    );
};

export default ConfigModalHeader;
